import React from "react";
import "./PaymentsCard.css";

import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const ModernPaymentsCard = ({ title, type = "in", buttonText, data = [] }) => {
  return (
    <div className="modern-card">

      {/* Header */}
      <div className="modern-card-header">
        <div className="modern-title">
          <div className={`icon-circle ${type}`}>
            {type === "in" ? <ArrowDownRight size={18}/> : <ArrowUpRight size={18}/>}
          </div>
          {title}
        </div>

        {buttonText && (
          <button className="modern-btn">{buttonText}</button>
        )}
      </div>

      {/* Body */}
      <div className="modern-body">
        {data.map((section, index) => (
          <div key={index} className="modern-section">

            {section.section && (
              <div className="modern-section-title">
                {section.section}
              </div>
            )}

            {section.items.map((item, i) => (
              <div key={i} className="modern-row">

                <div className="row-left">
                  {item.label}
                  <span className="count">({item.count})</span>
                </div>

                <div className="row-right">
                  ₹ {item.value.toLocaleString()}
                </div>

              </div>
            ))}

          </div>
        ))}
      </div>

    </div>
  );
};

export default ModernPaymentsCard;